import { Checkbox, DatePicker, Form, Input, Select } from "antd";
import { CalendarBlank, MinusCircle, PlusCircle } from "assets/icons";
import { SHIFT_TYPES } from "constant";
import { DATE_FORMAT_2 } from "constant/date";
import dayjs, { Dayjs } from "dayjs";
import { uniqueId } from "lodash";
import { SelectedItem } from "page/ManageShiftStaff/type";
import { useEffect, useMemo, useState } from "react";
import "dayjs/locale/ja";

interface IProps  {
  selectedItems: SelectedItem[];
  familyName: string
}

const RenderDateForm = ({
  selectedItems,
  familyName

}:IProps) => {
  const nurseId = selectedItems[0]?.nurseId;
  const [dataDate, setDataDate] = useState<SelectedItem[]>(selectedItems);
  const form = Form.useFormInstance();
  const handleOnchangeDate = (date: Dayjs | null, index: number) => {
    if (dataDate[index]) {
      const dataDateClone = [...dataDate];
      dataDateClone[index].date = date || null;
      setDataDate(dataDateClone);
    }
  };

  const handleAdd = (index: number) => {
    const firstPartData = dataDate.slice(0, index + 1);
    const lastPartData = dataDate.slice(index + 1, dataDate.length);
    setDataDate([
      ...firstPartData,
      {
        date: null,
        indexCol: selectedItems[0].indexCol,
        indexRow: selectedItems[0].indexRow,
        nurseId: nurseId,
        key: uniqueId("at_modal_"),
      },
      ...lastPartData,
    ]);
  };

  const handleRemove = (key: string) => {
    if (dataDate.length === 1) return;
    const newDataDate = dataDate.filter((item) => item.key !== key);
    setDataDate(newDataDate);
  };

  useEffect(() => {
    const result = selectedItems.reduce(
      (acc, item) => {
        if (acc[item.nurseId]?.dates) {
          acc[item.nurseId].dates = {
            ...acc[item.nurseId].dates,
            [item.key]: item.date,
          };
        } else {
          acc[item.nurseId] = {
            dates: { [item.key]: item.date },
          };
        }

        return acc;
      },
      {} as Record<string, { dates: Record<string, string | Dayjs | null> }>
    );

    const values = form.getFieldsValue();
    form.setFieldsValue({ ...values, ...result });
    if (selectedItems.length === 1) {
      selectedItems[0].shiftType &&
        form.setFieldValue([nurseId, "shift_type"], selectedItems[0].shiftType);
      selectedItems[0].note &&
        form.setFieldValue([nurseId, "note"], selectedItems[0].note);
    }
    setDataDate(selectedItems);
  }, [selectedItems]);

  const disabledDates = useMemo(
    () => dataDate.map((item) => dayjs(item.date)),
    [dataDate]
  );
  const disableSpecificDates = (current: dayjs.Dayjs) =>
    disabledDates.some((date) => date.isSame(current, "day"));
  const optionShiftType = Object.values(SHIFT_TYPES);

  return (
    <div>
      <div className=" sticky top-0 z-50 bg-white">
        <div className=" bg-slate-300 p-2  border font-bold rounded-t-xl text-sm text-[#010A02] !pr-1 truncate">
          {familyName}
        </div>
      </div>
      <div className="  border-b border-x p-4  rounded-b-xl shadow-md">
        {dataDate.map((item, index) => (
          <div className="flex" key={item.key}>
            <Form.Item
              label={index === 0 ? "日にち" : ""}
              name={[item.nurseId, "dates", item.key]}
              className="flex-1"
              rules={[{ required: true, message: "必須項目です。" }]}
              validateTrigger="submit"
              getValueProps={(value) => ({
                value: value ? dayjs(value) : null,
              })}
              normalize={(value: Dayjs | null) =>
                value ? value.format(DATE_FORMAT_2) : null
              }
            >
              <DatePicker
                placeholder="選択してください"
                className="w-full !border-[#00000026] pr-8"
                format={DATE_FORMAT_2}
                onChange={(date) => {
                  handleOnchangeDate(date, index);
                }}
                suffixIcon={
                  <div className="text-[#010A02] -mr-7">
                    <CalendarBlank />
                  </div>
                }
                disabledDate={disableSpecificDates}
              />
            </Form.Item>

            <div
              className={`flex ml-3 h-8 items-center text-[#E07B2E] ${index !== 0 ? "" : "mt-[30px]"}`}
            >
              <div
                className=" cursor-pointer mr-1"
                onClick={() => handleAdd(index)}
              >
                <PlusCircle />
              </div>
              <div
                className={`${
                  dataDate.length === 1
                    ? "cursor-not-allowed opacity-40"
                    : "cursor-pointer"
                } `}
                onClick={() => handleRemove(item.key)}
              >
                <MinusCircle />
              </div>
            </div>
          </div>
        ))}
        {nurseId && (
          <Form.Item
            label={"対応シフト"}
            name={[nurseId, "shift_type"]}
            className="flex-1"
            rules={[{ required: true, message: "必須項目です。" }]}
          >
            <Select
              placeholder="対応シフトを選択してください"
              className="w-full !border-[#00000026]"
              options={optionShiftType}
            />
          </Form.Item>
        )}
        <Form.Item label={"備考欄"} name={[nurseId, "note"]} className="flex-1">
          <Input />
        </Form.Item>
        <div className="flex items-center">
          <Form.Item
            name={[nurseId, "isDelete"]}
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox>削除</Checkbox>
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default RenderDateForm;
